import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import TextField from '@material-ui/core/TextField';
import './index.css';

function TextAreaWithOnChange(props) {
    const { control } = useFormContext();
    const { name, label, required, errorlist, defaultValue, rows, maxRows, disabled} = props;
    let isError = false;
    let errorMessage = '';
    if (errorlist && errorlist.hasOwnProperty(name)) {
        isError = true;
        errorMessage = errorlist[name].message;
    }

    const inputRef = React.useRef();
    const handleOnclick = () => {
        inputRef.current.focus();
    };

    const convertArrayToTextArea = (arrText) => {
        let output = arrText;
        if (Array.isArray(arrText)) {
            if (arrText.length == 1) {
                output = arrText[0];
            } else {
                output = arrText.join('\n');
            }
        }
        return output;
    }

    return (
        <Controller
            inputRef={inputRef}
            onClick={handleOnclick}
            name={name}
            control={control}
            defaultValue={defaultValue ? defaultValue : ''}
            render={({ value, onChange }) => {
                value = convertArrayToTextArea(value);
                return (
                <TextField
                    value={value ? value : ''}
                    defaultValue={defaultValue ? defaultValue : ''}
                    label={label}
                    multiline
                    rows={rows}
                    disabled ={disabled}
                    maxRows={maxRows}
                    onChange={(e) => {
                        onChange(e.target.value);
                        props.onChange(e);
                    }}
                    error={isError}
                    helperText={errorMessage}
                    className={props.className}
                    variant={props.variant}
                    autoComplete="off"
                />
                )
            }}
            rules={{ required: required || false }}
        />
    );
}

export default TextAreaWithOnChange;
